import { FormFieldTypes } from "../../../../../../data/formFieldType";

const initState = {
    contractAmount: null,
    consumptionTotal: null,
    consumptionTotal: null,
    expenseTotal: null,
    contractBasedonExpenses: null,
    marginPercentage: null,
    efficiencyRating: null,
    percentValueConsumedExpenses: null,
    percentTimeElapsed: null,
    contractIndexExpenses: null,
    percentValueConsumedConsumption: null,
    percentTimeElapsed: null,
    contractIndexConsumption: null,
};

export const reportCardConfig = {
    name: "Report Card",
    initialState: initState,
    section: [
        {
            sectionId: "reportCardSection",
            title: "Report Card Section",
            row: {},
            style: {
                sectionStyle: "col-lg-6 col-mb-5 pl-5 pb-2",
            },
            wrapperTemplate: <div className="form-card row"></div>,
            fields: [
                {
                    id: "contractAmount",
                    label: "Contract Total :",
                    Field_Name: "contractAmount",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "contractAmount",
                    fieldSetting: {
                        isLoading: false,
                        placeholder: "Enter Contract Total",
                        isDisable: true,
                    },
                    style: {
                        containerCss: "col-12 mb-3",
                    },
                },
                {
                    id: "consumptionTotal",
                    label: "Consumption :",
                    Field_Name: "consumptionTotal",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "consumptionTotal",
                    fieldSetting: {
                        isLoading: false,
                        placeholder: "Enter Consumption",
                        isDisable: true,
                    },
                    style: {
                        containerCss: "col-12 mb-3",
                    },
                },
                {
                    id: "expenseTotal",
                    label: "Expenses :",
                    Field_Name: "expenseTotal",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "expenseTotal",
                    fieldSetting: {
                        isLoading: false,
                        placeholder: "Enter Expenses",
                        isDisable: true,
                    },
                    style: {
                        containerCss: "col-12 mb-3",
                    },
                },
            ]
        },
        {
            sectionId: "reportCardSection1",
            title: "Contract Index - Based on Expenses",
            row: {},
            style: {
                sectionStyle: "col-lg-6 col-mb-5 pl-5 pb-2",
            },
            wrapperTemplate: <div className="form-card row"></div>,
            fields: [
                {
                    id: "revenueTotal",
                    label: "Revenue :",
                    Field_Name: "revenueTotal",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "revenueTotal",
                    fieldSetting: {
                        isLoading: false,
                        placeholder: "Enter Revenue",
                        isDisable: true,
                    },
                    style: {
                        containerCss: "col-12 mb-3",
                    },
                },
                {
                    id: "marginPercentage",
                    label: "Margin :",
                    Field_Name: "marginPercentage",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "marginPercentage",
                    fieldSetting: {
                        isLoading: false,
                        placeholder: "Enter Margin",
                        isDisable: true,
                    },
                    style: {
                        containerCss: "col-12 mb-3",
                    },
                },
                {
                    id: "efficiencyRating",
                    label: "Eficiency Rating :",
                    Field_Name: "efficiencyRating",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "efficiencyRating",
                    fieldSetting: {
                        isLoading: false,
                        placeholder: "Enter Eficiency Rating",
                        isDisable: true,
                    },
                    style: {
                        containerCss: "col-12 mb-3",
                    },
                },
            ]
        },
        {
            sectionId: "contractBasedonExpenses",
            title: "Contract Index - Based on Expenses",
            row: {},
            style: {
                sectionStyle: "col-lg-6 col-mb-5 pl-5",
            },
            wrapperTemplate: <div className="form-card row"></div>,
            fields: [
                {
                    id: "contractBasedonExpensesTitle",
                    label: "",
                    fieldType: FormFieldTypes.MAINFORMTITLE,
                    fieldSetting: {
                        formTitle: "Contract Index - Based on Expenses",
                    },
                    style: {
                        containerCss: "col-12 mb-4 ",
                    },
                },
                {
                    id: "percentValueConsumedExpenses",
                    label: "Percent Value Consumed :",
                    Field_Name: "percentValueConsumedExpenses",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "percentValueConsumedExpenses",
                    fieldSetting: {
                        isLoading: false,
                        placeholder: "Enter Percent Value Consumed",
                        isDisable: true,
                    },
                    style: {
                        containerCss: "col-12 mb-3 label-custom-width",
                    },
                },
                {
                    id: "percentTimeElapsed",
                    label: "Percent Time Elasped :",
                    Field_Name: "percentTimeElapsed",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "percentTimeElapsed",
                    fieldSetting: {
                        isLoading: false,
                        placeholder: "Enter Percent Time Elasped",
                        isDisable: true,
                    },
                    style: {
                        containerCss: "col-12 mb-3 label-custom-width",
                    },
                },
                {
                    id: "contractIndexExpenses",
                    label: "Contract Index :",
                    Field_Name: "contractIndexExpenses",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "contractIndexExpenses",
                    fieldSetting: {
                        isLoading: false,
                        placeholder: "Enter Contract Index",
                        isDisable: true,
                    },
                    style: {
                        containerCss: "col-12 mb-3 label-custom-width",
                    },
                },
            ]
        },
        {
            sectionId: "contractBasedonConsumptions",
            title: "Contract Index - Based on Consumptions",
            row: {},
            style: {
                sectionStyle: "col-lg-6 col-mb-5 pl-5",
            },
            wrapperTemplate: <div className="form-card row"></div>,
            fields: [
                {
                    id: "contractBasedonConsumptionsTitle",
                    label: "",
                    fieldType: FormFieldTypes.MAINFORMTITLE,
                    fieldSetting: {
                        formTitle: "Contract Index - Based on Consumptions",
                    },
                    style: {
                        containerCss: "col-12 mb-4",
                    },
                },
                {
                    id: "percentValueConsumedConsumption",
                    label: "Percent Value Consumed :",
                    Field_Name: "percentValueConsumedConsumption",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "percentValueConsumedConsumption",
                    fieldSetting: {
                        isLoading: false,
                        placeholder: "Enter Percent Value Consumed",
                        isDisable: true,
                    },
                    style: {
                        containerCss: "col-12 mb-3 label-custom-width",
                    },
                },
                {
                    id: "percentTimeElapsed",
                    label: "Percent Time Elasped :",
                    Field_Name: "percentTimeElapsed",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "percentTimeElapsed",
                    fieldSetting: {
                        isLoading: false,
                        placeholder: "Enter Percent Time Elasped",
                        isDisable: true,
                    },
                    style: {
                        containerCss: "col-12 mb-3 label-custom-width",
                    },
                },
                {
                    id: "contractIndexConsumption",
                    label: "Contract Index :",
                    Field_Name: "contractIndexConsumption",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "contractIndexConsumption",
                    fieldSetting: {
                        isLoading: false,
                        placeholder: "Enter Contract Index",
                        isDisable: true,
                    },
                    style: {
                        containerCss: "col-12 mb-3 label-custom-width",
                    },
                },
            ]
        }
    ]
}